import { Button, ResponsiveSection, Text } from '@stitch-fix/mode-react';
import type { BrandsValuePageData } from '../../types';
import styles from './index.module.scss';
interface FinalCtaSectionProps {
  data: BrandsValuePageData['finalCta'];
}
export const FinalCtaSection = ({
  data
}: FinalCtaSectionProps) => {
  return <section className={styles.section}>
      <ResponsiveSection width="xlarge" gutter="standard">
        <div className={styles.container}>
          <Text as="p" className={styles.eyebrow} setting="eyebrow-medium">
            {data.eyebrow}
          </Text>
          <Text as="h2" className={styles.title} setting="title-xxlarge">
            {data.title}
          </Text>
          <Text as="p" className={styles.description} setting="body-medium">
            {data.description}
          </Text>
          <div className={styles.cta}>
            <Button as="a" href={data.ctaHref} variant="filled-accent-large" width={{
            sm: 'fill',
            md: 'fit'
          }}>
              {data.ctaLabel}
            </Button>
          </div>
        </div>
      </ResponsiveSection>
    </section>;
};